import { useEffect, useState } from "react";

const images = [
  "Images/memo1.jpg",
  "Images/memo2.jpg",
  "Images/memo3.jpg",
  "Images/memo4.jpg",
];


export default function Hero({ title, description }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-white w-full flex flex-col items-center">
      <section className="relative w-full min-h-screen flex items-center justify-center text-center px-6 py-20">
        
        <div className="absolute inset-0 w-full h-full">
          {images.map((img, index) => (
            <div
              key={index}
              className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-[1500ms] 
              ${index === currentIndex ? "opacity-100" : "opacity-0"}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
        </div>

        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 text-white flex flex-col items-center">
          <h1 className="text-4xl md:text-6xl font-bold text-[#D9A05B]">
            {title}
          </h1>

          <p className="text-lg md:text-2xl max-w-3xl mt-4 text-[#F5E9D8]">
            {description}
          </p>

          <a
            href="https://us02web.zoom.us/j/5015391726"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 px-8 py-3 bg-[#D9A05B] text-[#1A1F2B] font-semibold rounded-full hover:bg-[#C9A86A] transition shadow-lg"
          >
            Join Worship
          </a>
        </div>
      </section>
    </div>
  );
}